/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-08-19 15:21:11
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-09-23 14:08:43
 * @FilePath: \h5-lcjc-formula\src\utils\category\Renal.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 肾脏病学 */

/** 对应的标题 */
const categoryMap = {
  RIFLE: 'RIFLE 分级',
  ProteinExcretion: '蛋白排泄量',
  ChronicKidneyDisease_CKD: '慢性肾脏病CKD分期',
  KDIGOAKI: 'KDIGOAKI分级',
  AnionGap_Urine: '阴离子间隙（尿）',
  ExcretionFraction_Mg: '排泄分数（镁）',
  ExcretionFraction_Ca: '排泄分数（钙）',
  IronDeficiency: '铁缺乏（Ganzoni）',
  NaCorrection_Sugar: 'Na校正（糖）',
  CaCorrection_Protein: 'Ca校正（蛋白质）',
  CaCorrection_Albumin: 'Ca校正（白蛋白）',
  NaCorrection_Albumen: 'Na校正（蛋白）',
  FEUrea: '排泄分数（尿素）',
  NaRevise: 'Na校正（血脂）',
  RIFLEGrade: 'RIFLE分级',
  AdrenalTumorStage: '肾上腺肿瘤分期',
  SerumSodiumCorrected: '血清钠纠正',
  DialysisEffe: 'Kt/V（URR）',
  RenalFailure: '肾衰指数（RF）',
  ArterialBloodGas: '动脉血气分析',
  Unit_conversionOfCreatinine: '肌酐'
}
/** 对应的描述 */
const categoryDescMap = {
  RIFLE: '急性肾损伤诊断标准',
  ProteinExcretion: '蛋白尿评估',
  ChronicKidneyDisease_CKD: '评估CKD患者病情进展',
  KDIGOAKI: '急性肾损伤诊断标准',
  AnionGap_Urine: '碳酸氢盐丢失原因',
  ExcretionFraction_Mg: '镁稳态',
  ExcretionFraction_Ca: '钙稳态',
  IronDeficiency: '贫血患者铁剂替代治疗',
  NaCorrection_Sugar: '血糖升高影响血钠水平',
  CaCorrection_Protein: '总钙水平随蛋白浓度改变',
  CaCorrection_Albumin: '低白蛋白血症时钙浓度的校正',
  NaCorrection_Albumen: '高蛋白血症影响血钠水平',
  FEUrea: '与FENa相似但不受利尿剂影响',
  NaRevise: '高脂血症影响血Na水平',
  RIFLEGrade: '评估急性肾损伤的严重程度',
  AdrenalTumorStage: '评估肾上腺肿瘤患者病情进展',
  SerumSodiumCorrected: '预测血钠变化',
  DialysisEffe: '透析有效性指数',
  RenalFailure: '评估肾功能衰竭病因',
  ArterialBloodGas: '相关指标及酸碱失衡类型'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Renal.js